import { addHours, isAfter } from "date-fns";

interface IsShiftAfterLeadTimeOptions {
  shiftStartDate: Date;
  leadTimeHours: number;
}

export function isShiftAfterLeadTime({
  shiftStartDate,
  leadTimeHours,
}: IsShiftAfterLeadTimeOptions): boolean {
  const now = new Date();
  const leadTimeEnd = addHours(now, leadTimeHours);

  return isAfter(shiftStartDate, leadTimeEnd);
}
